"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioVideoToggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isMacOS = _reactSdk.parsedUserAgent.getOS().name.toLowerCase() === "mac os";
var AudioVideoToggle = function AudioVideoToggle() {
  var _useAVToggle = (0, _reactSdk.useAVToggle)(),
    isLocalVideoEnabled = _useAVToggle.isLocalVideoEnabled,
    isLocalAudioEnabled = _useAVToggle.isLocalAudioEnabled,
    toggleAudio = _useAVToggle.toggleAudio,
    toggleVideo = _useAVToggle.toggleVideo;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [toggleAudio ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "Turn ".concat(isLocalAudioEnabled ? "off" : "on", " audio (").concat(isMacOS ? "⌘" : "ctrl", " + d)"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        active: isLocalAudioEnabled,
        onClick: toggleAudio,
        "data-testid": "audio_btn",
        children: !isLocalAudioEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MicOffIcon, {
          "data-testid": "audio_off_btn"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MicOnIcon, {
          "data-testid": "audio_on_btn"
        })
      }, "toggleAudio")
    }) : null, toggleVideo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "Turn ".concat(isLocalVideoEnabled ? "off" : "on", " video (").concat(isMacOS ? "⌘" : "ctrl", " + e)"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        active: isLocalVideoEnabled,
        onClick: toggleVideo,
        "data-testid": "video_btn",
        children: !isLocalVideoEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VideoOffIcon, {
          "data-testid": "video_off_btn"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VideoOnIcon, {
          "data-testid": "video_on_btn"
        })
      }, "toggleVideo")
    }) : null]
  });
};
exports.AudioVideoToggle = AudioVideoToggle;